export const CAMPAIGN_STATUSES = [
  { id: 'Active',   label: 'Active',   color: '#4CAF50' },
  { id: 'Upcoming', label: 'Upcoming', color: '#f59e0b' },
  { id: 'Expired',  label: 'Expired',  color: '#757575' },
];

// Status is never stored — always derived at display time.
export const deriveStatus = (startDate, endDate) => {
  if (!startDate || !endDate) return 'Upcoming';
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (today < new Date(startDate)) return 'Upcoming';
  if (today > new Date(endDate))   return 'Expired';
  return 'Active';
};

export const MEDIA_TYPES = ['Image', 'Video', '3D'];

// Human-readable duration: "2d 3h 15m" or "45s"
export const formatDuration = (totalSeconds) => {
  if (!totalSeconds || totalSeconds <= 0) return '0s';
  const d = Math.floor(totalSeconds / 86400);
  const h = Math.floor((totalSeconds % 86400) / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  const parts = [];
  if (d) parts.push(`${d}d`);
  if (h) parts.push(`${h}h`);
  if (m) parts.push(`${m}m`);
  if (s && !d) parts.push(`${s}s`);
  return parts.join(' ') || '0s';
};

// Cost Per Day = dailyRate × durationModifier  |  Total = costPerDay × days
export const computeCampaignCost = (dailyRate, startDate, endDate, durationModifier = 1.0) => {
  if (!startDate || !endDate || !dailyRate) return { costPerDay: 0, totalCost: 0, days: 0 };
  const days = Math.max(
    1,
    Math.ceil((new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24)) + 1,
  );
  const costPerDay = parseFloat((Number(dailyRate) * Number(durationModifier || 1)).toFixed(2));
  const totalCost  = parseFloat((costPerDay * days).toFixed(2));
  return { costPerDay, totalCost, days };
};
